import React, { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { Form } from '@kuzmycz/react-form-ula';
import { Button, Modal } from '../../../../Components/uielements';
import BioPlusTextField from '../../../../Components/form-fields/BioPlusTextField';
import DropDown from '../../../../Components/uielements/dropDown';
import {
  ModalButtonWrapper,
  ModalGap,
  OutlineButton,
} from '../../../../services/settings/appStyle/global.style';
import { IntlMessages } from '../../../../helper/langHelper';
import { ModalWrapper } from '../discountCoupon.style';
import { counponCreation } from '../../../../services/bioplus-services/discountCoupon';

const CouponModal = ({ onClose }) => {
  const [couponType, setCouponType] = useState('repeating');
  const [period, setPeriod] = useState(1);
  const queryClient = useQueryClient();

  const mutation = useMutation((payload) => counponCreation(payload), {
    onSuccess: async () => {
      await queryClient.invalidateQueries('couponList');
      onClose();
    },
    onError: (error) => {
      alert(`${error}`);
      onClose();
    },
  });

  const handleSubmit = (values) => {
    const value = {
      ...values,
      percentOff: Number(values?.percentOff),
      ...(couponType && { couponType: couponType }),
      ...(period && couponType === 'repeating' && { period: period }),
    };
    mutation.mutate(value);
  };

  const validator = () => {
    return undefined;
  };

  const handleSelectedValue = (value) => {
    setCouponType(value.value);
  };
  const handleSelectedPeriod = (value) => {
    setPeriod(value.value);
  };

  return (
    <>
      <Modal isOpen={true} onClose={onClose} title={'Discount Coupon'}>
        <Form validator={validator} onSubmit={handleSubmit}>
          <ModalWrapper>
            <ModalGap>
              <BioPlusTextField name="name" label="Coupon Name" fullWidth />
              <BioPlusTextField name="percentOff" label={'Percent Off'} fullWidth />
              <DropDown
                options={[
                  { value: 'repeating', label: 'Repeating' },
                  { value: 'once', label: 'Once' },
                  { value: 'forever', label: 'Forever' },
                ]}
                selectedOption={handleSelectedValue}
                name="couponType"
                label="Coupon Type"
                defaultValue={couponType}
              />
              {couponType === 'repeating' && (
                <DropDown
                  options={[
                    { value: '1', label: '1' },
                    { value: '2', label: '2' },
                    { value: '3', label: '3' },
                    { value: '4', label: '4' },
                    { value: '5', label: '5' },
                    { value: '6', label: '6' },
                  ]}
                  selectedOption={handleSelectedPeriod}
                  name="period"
                  label="Period"
                  defaultValue={period}
                />
              )}
            </ModalGap>
            <ModalButtonWrapper>
              <OutlineButton onClick={onClose}>
                <IntlMessages id="modal.button.cancel" defaultValue="Cancel" />
              </OutlineButton>
              <Button varient="normal" type="submit">
                <IntlMessages id="modal.button.submit" defaultValue="Submit" />
              </Button>
            </ModalButtonWrapper>
          </ModalWrapper>
        </Form>
      </Modal>
    </>
  );
};

export default CouponModal;
